<div class="modal-content ">
  <!-- Cabeçalho do Modal com título e botão de fechar -->
  <div class="modal-header">
    <h5 class="modal-title">Vincular usuário - Lista: {{list.nomeLista}}</h5>
    <button type="button" class="btn-close" aria-label="Fechar" (click)="activeModal.dismiss()"></button>
  </div>

  <div class="modal-body p-4">
    <h4 class="text-center mb-4">Administre o vínculo de usuários à lista desejada.</h4>
    <form [formGroup]="vincularUsuarioForm" (ngSubmit)="onSubmit()">
      <input hidden formControlName="listaContatoGeradoid">
      <!-- Campo Nome -->
      <div class="col-12 d-flex justify-content-md-between mb-3">
        <div class="col-4">

          <label class="form-label" for="attendantForm">Usários para vínculo</label>
          <select formControlName="usuarioId" class="form-select" id="attendantForm" [ngClass]="{
              'is-invalid':
              vincularUsuarioForm.controls.usuarioId.errors &&
              vincularUsuarioForm.get('contato')?.touched,
            }">
            <option value="" selected disabled>Selecione um contato</option>
            <option *ngFor="let row of users" [value]="row.id">{{ row.nomeCompleto }}</option>
          </select>
          <div class="invalid-feedback" *ngIf="
                      vincularUsuarioForm.controls.usuarioId.errors &&
                      vincularUsuarioForm.get('contato')?.touched
                    ">
            O contato é obrigatório.
          </div>
          <div class="text-start mt-3">
            @if(!isLoading){
              <button type="submit" class="btn btn-sm btn-success w-md">Adicionar</button>
            }@else{
              <button type="button" class="btn btn-sm btn-primary btn-block">
                <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                Trabalhando
              </button>
            }
          </div>
        </div>

        <div class="vr"></div>
        <div class="choices col-md-12 col-lg-7" data-type="text">
          <label class="form-label" for="attendantForm">Usuários já vinculados</label>
          <div class="choices__inner">

            @for (row of atendentes; track $index) {
            <div class=" choices__list--multiple">
              <div class="choices__item" aria-selected="true" data-deletable="">

                <span>{{row.nome}}</span> <button (click)="excluirAtendente(row.id)" type="button" class="choices__button">Remove item</button>

              </div>

            </div>
            }



          </div>
        </div>
      </div>

    </form>
  </div>
</div>